export default __webpack_public_path__ + "static/media/TLS.5debebd2.svg";